import dayjs from "dayjs";
import { useMemo } from "react";
import { unixToSlot } from "../utils/slotDates";
import { useQueryProposal } from "./useQueryProposal";
import { useSundaeAudit } from "./useSundaeAudit";
export const useProposalUtils = () => {
    const { data } = useQueryProposal();
    const audit = useSundaeAudit();
    const results = audit?.results ?? [];
    const hasEnded = useMemo(() => Number(data?.proposal?.voteEnd.slot) < unixToSlot(dayjs().unix()), [data?.proposal?.voteEnd.slot]);
    const hasStarted = useMemo(() => Number(data?.proposal?.voteStart.slot) < unixToSlot(dayjs().unix()), [data?.proposal?.voteStart.slot]);
    const resultsReady = useMemo(() => hasEnded && results.length > 0, [hasEnded, audit]);
    return {
        hasEnded,
        hasStarted,
        resultsReady
    };
};
//# sourceMappingURL=useProposalUtils.js.map